import { can, PortalPermissions } from "../../../../config/permissions";
import React, {ChangeEvent, useEffect, useMemo, useReducer, useRef, useState} from 'react';
import {Input, Popconfirm} from 'antd';
import LoadingOverlay from "../../../../components/LoadingOverlay";
import {ResponsiveTable, TableContainer, ResponsiveColumn, ResponsiveRow} from "../styles";
import Table, {TableColumn} from "../../../../components/Table";
import {DeleteOutlined, EyeOutlined} from "@ant-design/icons";
import {getAxiosInstanceLinkPagamento} from "../../../../services/providers/api";
import {formatMoney} from "../../../dashboardComercial/utils";
import LinkDeAssinaturaService from "../../service/linkDeAssinaturaService";
import {getErrorMessage} from "../../../../utils/getErrorMessage";

interface DataType {
  paymentDate: string;
  tempo: string;
  empresa: string;
  document: string;
  businessName: string;
  acquirer: string;
  terminal: string;
  tefTerminal: string;
  brand: string;
  authorizationNumber: string;
  cardNumber: string;
  productName: string;
  acquirerNsu: string;
  originalValue: string;
  status: string;
  parcels: string;
  terminalSerialNumber: string;
  liquidValue: string;
  value: string;
  merchant: string;
}

type DataIndex = keyof DataType;

const LiveTable: React.FC<any> = (props: any) => {
  const {dataFilter, setLink} = props;
  const linkDeAssinatura = new LinkDeAssinaturaService();
  const selectedBusiness = localStorage.getItem('selectedCompany') ? JSON.parse(localStorage.getItem('selectedCompany') as string) :null;
  const [isLoading, setIsLoading] = useState(false);
  const user = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo') as string) :null;
  const [assinaturas, setAssinaturas] = useState<any[]>([]);


  const filter = (type: string) => {
    const handleAdquirenteFilter = (value: any, record: any) => {
      return record[type].toLowerCase().includes(value.toLowerCase());
    };

    return handleAdquirenteFilter;
  };

  const handleDelete = async (id: string) => {
    try {
      setIsLoading(true);
      const responseStatus = await linkDeAssinatura.deleteLinkById(id);
      if (responseStatus === 200) await getLinksDePagamento();
    }

    catch (error) {
      console.log(error);
    }

    finally {
      setIsLoading(false);
    }
  }

  const getLinksDePagamento = async () => {
    try {
      setIsLoading(true);
      const response = await linkDeAssinatura.getAllLinks(selectedBusiness, user);
      setAssinaturas(response);
    }

    catch (error) {
      const errorMessage = getErrorMessage(error);
      console.log(errorMessage);
    }

    finally {
      setIsLoading(false);
    }
  }

  const formatMoney = (value:number) => {
    const formattedValue = (value / 100).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return formattedValue;
  };

  useEffect(() => {
    setAssinaturas(dataFilter)
  }, [dataFilter]);

  return (
    <div>

      <LoadingOverlay
        show={isLoading}
        relative
      />
      <TableContainer>
        <Table
          dataSource={dataFilter}
          pagination={false}
        >
          <TableColumn title="Nome"  dataIndex="name" key="name" onFilter={filter('name')} />
          <TableColumn title="Descrição"  dataIndex="description" key="description" onFilter={filter('description')} />
          <TableColumn title="Valor" render={formatMoney}   dataIndex="value" key="value" onFilter={filter('value')} />
          <TableColumn title="URL" render={(i: any, e: any) => <a onClick={ () => window.open(e.url, '_blank') }>{e.url}</a>}  dataIndex="url" key="url" onFilter={filter('url')} />
          <TableColumn title="Expira em"   dataIndex="expires_at" key="expires_at" onFilter={filter('expires_at')} />
          <TableColumn title="Periodicidade"   dataIndex="periodicidade" key="periodicidade" onFilter={filter('periodicidade')} />
          <TableColumn title="Status"   dataIndex="status" key="status" onFilter={filter('status')} />

          {can(PortalPermissions.assinaturas.historico.excluir) && (
            <TableColumn
              title="Excluir"
              dataIndex="excluir"
              key="excluir"
              render={(i: any, e: any) =>
                <Popconfirm
                  title="Deseja realmente excluir?"
                  cancelText="Cancelar"
                  okText="Excluir"
                  onConfirm={() => handleDelete(e.link_id)}
                >
                  <DeleteOutlined />
                </Popconfirm>
              }
            />
          )}
        </Table>
      </TableContainer>

      <ResponsiveTable>
        <ResponsiveRow style={{ borderBottom: '1px solid gray', borderRadius: '0px'}}>
          <ResponsiveColumn><h4>Valor</h4></ResponsiveColumn>
          <ResponsiveColumn><h4>Url</h4></ResponsiveColumn>
          <ResponsiveColumn><h4>Expira em</h4></ResponsiveColumn>
        </ResponsiveRow>
        { assinaturas.map((assinaturas) => {
          return (
            <ResponsiveRow style={{ backgroundColor: 'white',  boxShadow: "2px 2px 6px rgba(0, 0, 0, 0.2)"}}>
              <ResponsiveColumn style={{maxWidth: "92px"}}>
                <p><b>{formatMoney(assinaturas.value)}</b></p>
                <p>{assinaturas.periodicidade}</p>
              </ResponsiveColumn>

              <ResponsiveColumn style={{maxWidth: "200px"}}>
                <a
                  href={assinaturas.url}
                  style={{ paddingLeft: "15px", paddingRight: "15px", color: "blue", textDecoration: "underline"}}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {assinaturas.url}
                </a>
              </ResponsiveColumn>

              <ResponsiveColumn>
                <p>{assinaturas.expires_at}</p>
              </ResponsiveColumn>
            </ResponsiveRow>
          )
        })}
      </ResponsiveTable>
    </div>

  )
}

export default LiveTable;
